import {types} from '../../types';

const setGroupsAction = (payload) => {
    return {
        type: types.cashier.SET_GROUPS,
        payload,
      }
}

const setUsersAction = (payload) => {
  return {
      type: types.cashier.SET_USERS,
      payload,
    }
}

export {
  setGroupsAction as SetGroupsAction,
  setUsersAction as SetUsersAction
}